const observer = new MutationObserver((mutationsList, observer) => {
	for (let mutation of mutationsList) {
		if (mutation.type === 'childList') {
			if (mutation.target.tagName === 'PRODUCT-RECOMMENDATIONS') {
             	relatedProductsSlider();
				 updatePrices();
				observer.disconnect();
				break;
			}
			
		}
	}
});

const config = {
	childList: true,
	subtree: true
};

observer.observe(document.body, config);

function toggleActiveClass(selectors) {
    document.querySelectorAll(selectors).forEach(element => {
        element.addEventListener('click', function(e) {
            if (e.target.matches(selectors)) {
                element.classList.toggle('active');
            }
        });
    });
}

toggleActiveClass('.hon-header__accordian, #hon-header__accordian');
toggleActiveClass('.hon-product__category, #hon-header__accordian');

